module.exports = __webpack_public_path__ + "media/entities/2020-ad537574.png";